import { Box, Typography } from "@mui/material";

import { useTheme } from "@mui/material/styles";

const Card = ({ width, height, sx, title, children }) => {
  const theme = useTheme();

  const cardWidth = width ? width : "auto";
  const cardHeight = height ? height : "auto";

  return (
    <Box
      width={cardWidth}
      height={cardHeight}
      borderRadius={2}
      boxShadow={4}
      sx={sx}
    >
      {title ? (
        <Box
          sx={{
            height: "30px",
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "sticky",
            top: 0,
          }}
        >
          <Typography>{title}</Typography>
        </Box>
      ) : null}
      <Box sx={{ height: "calc(100% - 30px)" }}>{children}</Box>
    </Box>
  );
};

export default Card;
